import { useMemo } from "react"
import { useDoesUserSatisfyConditions } from "#/services/contentful/conditional-gate"
import { filterContent } from "#/services/contentful/filter-content"
import type { ContentfulContentEntry } from "#/services/contentful/contentful-content-entry"
import type { ContentNode } from "./types"

export function useFilteredContent(
  entries: ContentfulContentEntry[],
  allowConditionsOverride = false
): { content: ContentNode[]; isLoading: boolean } {
  const { doesUserSatisfyConditions, isLoading } = useDoesUserSatisfyConditions(allowConditionsOverride)

  const content = useMemo(() => {
    if (isLoading) return []
    return filterContent(entries, doesUserSatisfyConditions)
  }, [entries, doesUserSatisfyConditions, isLoading])

  return { content, isLoading }
}
